import { toValidDate } from "~/utils/formatDateCounter";
import { formatPercentageValue } from "~/utils/formatValue";

import type { ICitationLeader } from "../types";

const MONTH = new Intl.DateTimeFormat("en-US", {
  month: "short",
  timeZone: "UTC",
});

const TIME = new Intl.DateTimeFormat("en-US", {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
  timeZone: "UTC",
});

/**
 * The Cite tab's ready-to-publish sentence (PH-1281): the leading outcome, its
 * PH Consensus, how many platforms it is weighted across and when it last
 * changed, in UTC. The event is named in brackets unless the outcome already is
 * the event (a one-outcome event), so it is never said twice. null when the
 * update time is not a date.
 */
export const getCitationText = (
  eventTitle: string,
  { outcome, chance, platformCount, updatedAt }: ICitationLeader
): string | null => {
  const date = toValidDate(updatedAt);

  if (!date) return null;

  const percent = formatPercentageValue(chance * 100, {
    maximumFractionDigits: 0,
    needToAbs: false,
  });
  const platforms = platformCount === 1 ? "platform" : "platforms";
  const isEventItself =
    outcome.trim().toLowerCase() === eventTitle.trim().toLowerCase();
  const subject = isEventItself
    ? `${outcome} at ${percent}`
    : `${outcome} at ${percent} (${eventTitle})`;
  const stamp = `${date.getUTCDate()} ${MONTH.format(date)} ${date.getUTCFullYear()}, ${TIME.format(date)} UTC`;

  return `PH Consensus puts ${subject}, weighted by trading volume across ${platformCount} prediction market ${platforms}. Source: PredictionHero, ${stamp}.`;
};
